import axiosInstance from '../../../config/axiosInstance';
import { LeadValidation } from "../Views/Validation/LeadValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};
const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
  event.preventDefault();
  const formErrors = LeadValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      formData.formData.ClientID = CompanyID;
      const UserID = localStorage.getItem("UserID");
      formData.formData.UserID = UserID;
      const formDataToSend = new FormData();

      formDataToSend.append(
        "formData",
        JSON.stringify(formData.formData)
      );

      formDataToSend.append(
        "tableData",
        JSON.stringify(
          formData.tableData.map(item => ({
            ...item,
            AttachmentFile: undefined
          }))
        )
      );

      formData.tableData.forEach((item, index) => {

        if (item.File instanceof File) {

          formDataToSend.append(
            `Attachment_${index}`,
            item.File
          );
        }
      });

      const response = await axiosInstance.post(
        `/Lead/CreateLead`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      localStorage.setItem('LeadID', response.data.LeadID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };